import { render, staticRenderFns } from "./formOption.vue?vue&type=template&id=035f0813&scoped=true"
import script from "./formOption.vue?vue&type=script&lang=js"
export * from "./formOption.vue?vue&type=script&lang=js"
import style0 from "./formOption.vue?vue&type=style&index=0&id=035f0813&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035f0813",
  null
  
)

export default component.exports